import { render, staticRenderFns } from "./CustomerOldDebts.vue?vue&type=template&id=12a412eb&"
import script from "./CustomerOldDebts.vue?vue&type=script&lang=js&"
export * from "./CustomerOldDebts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports